import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { globalReset } from '@/store/actions';
import { IAIUsage } from '@/common/interface';

interface IAIUsageState {
    usage: IAIUsage | null;
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
}

const initialState: IAIUsageState = {
    usage: null,
    status: 'idle',
};

const aiUsageSlice = createSlice({
    name: 'aiUsage',
    initialState,
    reducers: {
        fetchAIUsageRequest: (state: IAIUsageState) => {
            state.status = 'loading';
        },
        fetchAIUsageSuccess: (state: IAIUsageState, action: PayloadAction<IAIUsage>) => {
            state.usage = action.payload;
            state.status = 'succeeded';
        },
        fetchAIUsageFailure: (state: IAIUsageState) => {
            state.status = 'failed';
        },
    },
    extraReducers: (builder) => {
        builder.addCase(globalReset, (state) => {
            Object.assign(state, initialState);
        });
    },
});

export const { fetchAIUsageRequest, fetchAIUsageSuccess, fetchAIUsageFailure } = aiUsageSlice.actions;

export default aiUsageSlice.reducer;
